

import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Importă router-ul
import { createI18n } from 'vue-i18n';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'font-awesome/css/font-awesome.min.css';
import "@/assets/style.css";

import en from './locales/en.json';
import ro from './locales/ro.json';
import bg from './locales/bg.json';
import axios from "axios";
import 'animate.css';
import { euroRateMixin } from "@/mixins/EuroRateMixin";

axios.defaults.withCredentials = true; // Include cookie-ul de sesiune automat
axios.defaults.baseURL = "https://api.feribot-eurobac.ro/client/api/";
const i18n = createI18n({
  locale: 'ro',
  fallbackLocale: 'en',
  messages: { en, ro, bg },
});

const app = createApp(App);
app.mixin(euroRateMixin); 
app.use(router); // Asociază router-ul aplicației
app.use(i18n);   // Asociază i18n
app.mount('#app'); // Montează aplicația
